
import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

interface CustomDropDownOption {
  value: string;
  label: string;
}

interface CustomDropDownProps {
  value: string;
  onChange: (value: string) => void;
  options: CustomDropDownOption[];
  placeholder?: string;
  width?: number | string;
  height?: number | string;
  error?: boolean;
  className?: string;
  name?: string;
  menuwidth?: number;
  menuHeight?: number;

}

const CustomDropDown: React.FC<CustomDropDownProps> = ({
  value,
  onChange,
  options,
  placeholder = "Select an option",
  width = "100%", // Default to 100% for responsiveness
  height = 40,
  error = false,
  className = "",
  menuwidth = 0,
  menuHeight = "auto",
}) => (
  <Select
    className={className}
    value={value}
    onChange={(e) => onChange(e.target.value as string)}
    displayEmpty
    renderValue={(selected) =>
      selected ? (
        options.find((opt) => opt.value === selected)?.label || ""
      ) : (
        <span style={{ color: "#aaa" }}>{placeholder}</span>
      )
    }
    sx={{
      minHeight: height,
      height: height,
      width: width,
      maxWidth: "100%", // Responsive: never exceed parent width
      padding: "8px 40px 8px 12px",
      borderRadius: "10px",
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20stroke='%23666'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%3E%3Cpolyline%20points='6,9%2012,15%2018,9'%3E%3C/polyline%3E%3C/svg%3E\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      backgroundSize: "16px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      appearance: "none",
      backgroundColor: "white",
      border: error ? "2px solid #e28619" : "1.5px solid rgb(194, 192, 192)",
      transition: "border-color 0.2s",
      boxShadow: "none",
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none !important",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: "10px",
        paddingRight: "0 !important",
      },
      "& .MuiSelect-select": {
        padding: "6px 12px",
        minHeight: height,
        height: height,
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        borderRadius: "10px",
        backgroundColor: "white !important",
      },
      "&.Mui-focused": {
        borderColor: error ? "#e28619" : "#e0e0e0",
        boxShadow: "none",
      },
      "&.Mui-selected:hover": {
        backgroundColor: "white !important",
      },
      "&:hover": {
        backgroundColor: "transparent !important",
        borderColor: error ? "#e28619" : "#e0e0e0",
      },
      "@media (max-width: 600px)": {
        width: "100%",
        minWidth: "0",
        fontSize: "14px",
      },
    }}
    MenuProps={{
      PaperProps: {
        style: {
          padding: 10,
          marginTop: 6,
          width: typeof width === "number" ? `${width}px` : width,
          minWidth: typeof width === "number" ? `${width}px` : width,
          maxWidth: typeof width === "number" ? `${width}px` : width,
          minHeight: "auto",
          maxHeight: menuHeight,
          //   minWidth: typeof width === "number" ? `${width}px` : width,
          //   maxWidth: typeof width === "number" ? `${width}px` : width,
          maxWidth: "100vw",
          borderRadius: 10,
          paddingTop: 6,
          paddingLeft: 6,
          paddingRight: 6,
          paddingBottom: 11,
          backgroundColor: "white",
        },
      },
      MenuListProps: {
        style: {
          padding: 0,
        },
      },
    }}
  >
    {options.map((option) => (
      <MenuItem
        key={option.value}
        value={option.value}
        sx={{
          padding: "8px",
          minHeight: "20px",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "transparent !important",
            color: "#2463EB",
          },
          "&.Mui-selected": {
            backgroundColor: "white !important",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "white !important",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent !important",
          },
        }}
      >
        <span tabIndex={0} title={option.label}>
          {option.label}
        </span>
      </MenuItem>
    ))}
  </Select>
);

export default CustomDropDown;

